import Vue from 'vue'

import auth            from '@websanova/vue-auth/src/v2.js';
import authBearer      from '@websanova/vue-auth/src/drivers/auth/bearer.js';
import httpAxios       from '@websanova/vue-auth/src/drivers/http/axios.1.x.js';
import routerVueRouter from '@websanova/vue-auth/src/drivers/router/vue-router.2.x.js';
import oauth2Google    from '@websanova/vue-auth/src/drivers/oauth2/google.js';
import oauth2Github    from './github-plugin'
import constants from "@/config/constants";

oauth2Google.params.client_id = constants.GOOGLE_CLIENT_ID;

Vue.use(auth, {
    plugins: {
        http: Vue.axios, // Axios
        // http: Vue.http, // Vue Resource
        router: Vue.router,
    },
    drivers: {
        auth: authBearer,
        http: httpAxios, // Axios
        // http: driverHttpVueResource, // Vue Resource
        router: routerVueRouter,
        oauth2: {
            google: oauth2Google,
            github: oauth2Github,
        }
    },
    options: {
        rolesKey: 'type',
        notFoundRedirect: {name: 'Dashboard'},
        loginData: {
            url: 'external/login',
            remember: false,
            staySignedIn: true,
            fetchUser: false
        },
        registerData: {
            url: 'external/register'
        },
        fetchData: {
            url: 'external/user',
            method: 'GET',
            enabled: false
        },
        refreshData: {
            url: 'external/refresh',
            method: 'GET',
            enabled: true,
            interval: 5
        },
        stores: ['storage', 'cookie'],
    }
});
